module.exports = __webpack_public_path__ + "img/file.3b35df64.svg";